<div class="header">
    <label>filters</label>

    <div class="spacer"></div>

    <cc-button
        [type]="'naked'"
        [disabled]="!metadataLoaded"
        (pressed)="showAddFilter()"
    >
        {{metadataLoaded ? 'Add Filter' : 'Loading Metadata...'}}
    </cc-button>

    <cc-button
        #anchorForAddFilterModal
        [type]="'naked'"
        (pressed)="clearAllFilters()"
    >
        Clear All Filters
    </cc-button>
</div>

@if (!noFilterableData) {
    <div class="filters">
        @for (filter of dashboardFilters; let i = $index; track i) {
            <div class="disp-table search-table-relative">
                <div class="disp-table-cell search-table-header">
                    <span class="text-inner">{{ filter.displayName }}</span>
                </div>

                <div class="disp-table-cell search-table-cell">
                    @if (filter.isMasterWidgetFilter) {
                        <div class="disp-table-cell is-master">
                            <span class="icon-filteroutline"></span>
                            <label>M</label>
                        </div>
                    }
                </div>

                <div class="disp-table-cell text-center search-table-select">
                    <span class="text-inner">{{ filter.criteria.toLowerCase() }}</span>
                </div>

                @if (filter.values) {
                    <div class="disp-table-cell filter-values-cell">
                        @if (filter.values.length !== 0 && filter.values.length < 5) {
                            @for (value of filter.values; let valueIndex = $index; track valueIndex) {
                                <cc-chip
                                    [option]="{ text: '' + (value === '' ? 'Blanks' : value), value: value }"
                                    [removable]="false"
                                >
                                </cc-chip>
                            }
                        }

                        @if (filter.values.length >= 5 || filter.values.length === 0) {
                            <cc-chip
                                [option]="{ text: filter.values.length + ' selected', value: 'unused' }"
                                [removable]="false"
                            >
                            </cc-chip>
                        }
                    </div>
                }

                @if (!filter.isMasterWidgetFilter) {
                    <cc-icon
                        [icon]="'edit-pencil'"
                        [size]="'small'"
                        (iconClicked)="onEditFilter(filter)"
                    >
                    </cc-icon>

                    <cc-icon
                        [icon]="'close'"
                        [size]="'small'"
                        (iconClicked)="deleteFilterEntry(i)"
                    >
                    </cc-icon>
                }
            </div>
        }
    </div>

    <cc-button class="save-filters-button" (pressed)="onApplyFilters()">Apply</cc-button>
} @else {
    <div class="no-data error">
        <span>NO FILTERS AVAILABLE</span>
    </div>
}

@if (!noFilterableData && showAddFilters) {
    <div
        class="add-filter-wrapper"
        [ccModal]="modalOptions"
        (dismissed)="showAddFilters = false"
    >
        <app-filterable-attribute (selectAttribute)="addNewAttribute($event)"></app-filterable-attribute>

        <app-filterable-value
            [selectedDashboardFilter]="newDashboardFilter"
            (addFilteredValues)="addNewFilterEntry($event)">
        </app-filterable-value>
    </div>
}

@if (showEditFilter) {
    <div
        class="edit-filter-wrapper"
        [ccModal]="modalOptions"
        (dismissed)="showEditFilter = false"
    >
        <app-filterable-value
            [selectedDashboardFilter]="filterUnderEdit"
            (addFilteredValues)="applyFilterEdit($event)">
        </app-filterable-value>
    </div>
}
